import React, { Component, useMemo } from 'react'  
import Select from 'react-select';
import axios from 'axios';
import {fetchData} from '../../../utils/data.js'
import ClusterMap from '../../elem/map/ClusterMap'
import withConfig from '../../wrappers/withConfig'
import { format } from "date-fns";
import PageNavigation from '../../../utils/PageNavigation'
import MapSearchResults from './MapSearchResults.js'
import urls from '../../../utils/constants/urls'
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const transformFromUpperLowerToNorthSouth = selectedFeature => {
    const { lowerLat, lowerLon, upperLat, upperLon } = selectedFeature
    return {
        north: upperLat,
        south: lowerLat,
        east: upperLon,
        west: lowerLon
    }
}

class Search extends Component {
    constructor (props) {
        super( props )
        this.handleStateChange = this.handleStateChange.bind(this);
        this.populateCounty = this.populateCounty.bind(this);
        this.handleMapChange = this.handleMapChange.bind(this);
        this.fetchListResults = this.fetchListResults.bind(this);
        this.fetchMapResults = this.fetchMapResults.bind(this);
        this.onMapReset = this.onMapReset.bind(this);
        
        this.apiURL= props.config.API_URL
        const defaultCoordinates = {
            north: 49.382808,
            south: 24.521208,
            east: -66.945392,
            west: -124.736342
        }

        const selectedCoordinates = props.initialBoundingBox ? props.initialBoundingBox : defaultCoordinates
        this.state = {
            query: '',
            mapResults: {},
            pageNo: 1,
            loading: false,
            message: '',
            selectedCoordinates: selectedCoordinates,
            defaultCoordinates: defaultCoordinates,
            mapCoordinates: defaultCoordinates,
            //state
            selectedState: null,
            stateNumber: '',
            stateNames: [],
            //county
            selectedCounty: null,
            countyNumber: '',
            countyNames: [],
            //city
            selectedCity: null,
            cityNames: [],
            cityName: '',
            //map
            stateLat: '',
            stateLon: '',
            //pagination
            totalResults: 0,
            totalPages: 0,
            currentPageNo: 0,
            resultsPerPage: 10,

        };

        this.cancel = '';
    }

    //pagination
    getPageCount = (total, denominator) => {
        const divisible = total % denominator === 0;
        const valueToBeAdded = divisible ? 0 : 1;
        return Math.floor(total / denominator) + valueToBeAdded;
    };

    handlePageClick = (event, type) => {
        const updatedPageNo =
                  'prev' === type
                      ? this.state.currentPageNo - 1
                      : this.state.currentPageNo + 1;
        if (!this.state.loading) {
            const { north, south, east, west } = this.state.mapCoordinates
            this.fetchListResults(north, south, east, west, updatedPageNo);
        }
    };

    onMapReset = () => {
        this.setState({ selectedCoordinates: this.state.defaultCoordinates, mapCoordinates: this.state.defaultCoordinates })
    }

    fetchListResults = ( north, south, east, west, pageNo ) => {
        // fetch the LIST results
        // if(event){
        //     console.log(event, "event")
        //     event.preventDefault()
        // }
        const listURL = `${this.apiURL}/fracfocus/wellsinbounds?north=${north}&south=${south}&east=${east}&west=${west}&page=${pageNo}&pagesize=${this.state.resultsPerPage}`
        
        axios.get( listURL, {
        } )
            .then( res => {
                const total = res.data.Count;
                const resultNotFound = ! res.data.Wells
                                        ? 'There are no more search results.'
                                        : '';
                this.setState({
                    // totalCount: res.Count.length,
                    listResults: res.data.Wells,
                    currentPageNo: pageNo,
                    message: resultNotFound,
                    loading: false
                })
            })
            .catch ( error => {
                if( axios.isCancel(error) || error ){
                    this.setState({
                        loading:false,
                        message: 'Failed to fetch list data. Please check network'
                    })
                    console.log(error)
                }
            })
    }

    fetchMapResults = ( north, south, east, west ) => {
        const mapURL = `${this.apiURL}/fracfocus/wellsinbounds?north=${north}&south=${south}&east=${east}&west=${west}`

        if( this.cancel ){
            this.cancel.cancel();
        }
        this.cancel = axios.CancelToken.source();

        axios.get( mapURL, {
            cancelToken: this.cancel.token
        } )
            .then( res => {
                const total = res.data.Count;
                const totalPagesCount = this.getPageCount( total, this.state.resultsPerPage );
                const resultNotFound = ! res.data.Wells
                                        ? 'There are no more search results.'
                                        : '';
                this.setState({
                    mapResults: res.data.Wells,
                    message: resultNotFound,
                    loading: false,
                    totalResults: total,
                    currentPageNo: 1,
			        totalPages: totalPagesCount,
                })
            })
            .catch ( error => {
                if( axios.isCancel(error) || error ){
                    this.setState({
                        loading:false,
                        message: 'Failed to fetch the data. Please check network'
                    })
                    console.log(error)
                }
            })
    }

    handleMapChange = ( north, south, east, west ) => {
        this.setState({ pageNo: 1 })
        this.setState({
            mapCoordinates: {
                north: north,
                south: south,
                east: east,
                west: west
            }
        })
        this.fetchListResults(north, south, east, west, 1)
        this.fetchMapResults(north, south, east, west )
    };

    populateCounty(state_no) {
        const countySearchURL = `${this.apiURL}/state/countiesbystateid?stateid=${state_no}`
        const then = data => {
            const resultNotFound = ! data.length
                    ? 'There are no more search results.'
                    : '';
                this.setState({
                    results: data,
                    message: resultNotFound,
                    loading: false
                })
                this.setState({ countyNames: data.data })
        }
        const onError = error => {
            this.setState({
                    loading:false,
                    message: 'Failed to fetch the data. Please check network'
                })
            console.log(error)
        }
        fetchData(countySearchURL, then, onError)
    };

    populateCity(state_no, county_no) {
        const citySearchURL = `${this.apiURL}/state/citiesbystateid?stateid=${state_no}`
        const then = data => {
            const resultNotFound = ! data.length
                    ? 'There are no more search results.'
                    : '';
                this.setState({
                    results: data,
                    message: resultNotFound,
                    loading: false
                })
                this.setState({ cityNames: data.data })
        }
        const onError = error => {
            this.setState({
                    loading:false,
                    message: 'Failed to fetch the data. Please check network'
                })
            console.log(error)
        }
        fetchData(citySearchURL, then, onError)
    };

    handleOnInputChange = ( event ) => {
        const query = event.target.value;
        this.setState({ query, loading: true, message:'' }, () => {
        });
    };

    handleStateChange(event) {
        // either way- show input as null, or value
        this.setState({selectedState: event})
        if (event != null) {
            this.setState({ 
                stateNumber: event.value, 
                selectedCity: '',
                selectedCounty: '',
                selectedCoordinates: transformFromUpperLowerToNorthSouth(event) 
            })
            this.populateCounty(event.value)
            this.populateCity(event.value)
        }
        else{
            this.setState({ 
                //api values
                stateNumber: '', 
                countyNumber: '', 
                cityName: '',
                //dropdown values
                countyNames: [], 
                cityNames: [],
                //form values
               selectedState: '', 
               selectedCounty: '', 
               selectedCity: '' 
            })
        }
    }

    handleCountyChange = (event) => {
        this.setState({ 
            selectedCounty: event, 
        })
        if(event != null){
            this.setState({ 
                selectedCity: '',
                countyNumber: event.value, 
                selectedCoordinates: transformFromUpperLowerToNorthSouth(event)  
            })
        // this.populateCity(this.state.stateNumber, event.value)
        }
        else{
            //api params & form values
            this.setState({ 
                countyNumber: '',
                selectedCity: '' 
            })
        }
    }

    handleCityChange = (event) => {
        // TODO: update selectedCoords here
        this.setState({ selectedCity: event })
        if(event != null){
            this.setState({ 
                selectedCounty: '',
                countyNumber: '', 
                selectedCoordinates: transformFromUpperLowerToNorthSouth(event)  
            })
        }
        else{
            //api param & form value
            this.setState({ cityName: '', selectedCity: '' })
        }
    }

    fetchStates() {
        const stateURL = `${this.apiURL}/state/states`
        const then = data => {
            this.setState({stateNames : data.data})
        }
        function onError(error){
            console.log(error)
        }
        fetchData(stateURL, then, onError)
    }

    componentDidMount() {
        // this () runs once on page load
        this.fetchStates()
    }

    render() {
        const { query, stateNames, selectedState, selectedCounty, countyNames, cityNames, selectedCity} = this.state;
        const { loading, message, currentPageNo, totalPages } = this.state;
        const showPrevLink = 1 < currentPageNo;
        const showNextLink = totalPages > currentPageNo;
        const date = format(new Date(), 'MM-dd-yyyy');
        const showing_start = (this.state.currentPageNo == 1 || 0) ? 1 : (this.state.resultsPerPage * (this.state.currentPageNo-1)) + 1
        const showing_end = this.state.resultsPerPage * this.state.currentPageNo

        return(
            <div className="search_panel">
                <Helmet>
                    <title>Map Search</title>
                    <link rel="icon" href="/favicon.ico" />
                </Helmet>
                <h2 className="findwells">Find a well in your area</h2>
                <form className="map_form" onSubmit={(event) => this.fetchMapResults(event, this.state.pageNo, this.state.query)}>
                    <div className="map_search_panel">
                        <div className="map_advanced_input">
                            <label>State</label>
                            <Select options={ stateNames.map(x=>({
                                label: x.StateName, 
                                value: x.State_No, 
                                lowerLat: x.LowerLat, 
                                lowerLon: x.LowerLong, 
                                upperLat: x.UpperLat, 
                                upperLon: x.UpperLong, 
                                }
                            )) } value={selectedState} onChange={this.handleStateChange} isClearable={this.handleStateChange} placeholder='Select A State'/>
                        </div>
                        <div className="map_advanced_input">
                            <label>County</label>
                            <Select options={ countyNames.map(x=>({
                                label: x.CountyName, 
                                value: x.Code,
                                lowerLat: x.LowerLat, 
                                lowerLon: x.LowerLong, 
                                upperLat: x.UpperLat, 
                                upperLon: x.UpperLong,
                                })) 
                                } 
                                value={selectedCounty} onChange={this.handleCountyChange} isClearable={this.handleCountyChange} isDisabled={this.state.selectedState ? false : true} placeholder='Select A County'/>
                        </div>
                        <div className="map_advanced_input">
                            <label>City</label>
                            <Select options={ cityNames.map(x=>({
                                label: x.CityName, 
                                value: x.CityName,
                                lowerLat: x.LowerLat, 
                                lowerLon: x.LowerLong, 
                                upperLat: x.UpperLat, 
                                upperLon: x.UpperLong,
                                })) 
                                } 
                                value={selectedCity} onChange={this.handleCityChange} isClearable={this.handleCityChange} isDisabled={this.state.selectedState ? false : true} placeholder='Select A City'/>
                        </div>
                        {/* <button className="search_button" type="submit"><i className="fa fa-search" aria-hidden="true" /> SEARCH</button><br /> */}
                    </div>
                    <div className="return_adv">
                        <a className="back_to_map" href={`${urls.basename}/advanced`}>SWITCH TO ADVANCED SEARCH</a>
                    </div>
                    <div className="cluster_map">
                        {/* {this.state.selectedState ?  */}
                            <ClusterMap mapResults={this.state.mapResults} handleMapChange={this.handleMapChange} onReset={this.onMapReset} defaultBoundingBox={this.state.defaultCoordinates} initialBoundingBox={this.state.selectedCoordinates} lat = {this.state.stateLat ? this.state.stateLat : '39.8283'} lon = {this.state.stateLon ? this.state.stateLon : '-98.5795'}/>
                            {/* : <ClusterMap initialBoundingBox={this.state.defaultCoords} />} */}
                        </div>
                    </form>

                    {/* Results Component  */}
                    {this.state.mapResults.length < 20000 ?
                    <MapSearchResults 
                        mapResults={this.state.listResults}
                        totalhits={this.state.totalResults}
                    />
                     : 'Zoom in on map to see results.'} 

                    {/* Pagination Component  */}
                    {this.state.mapResults.length < 20000 ?
                        <PageNavigation
                            totalPages={totalPages}
                            currentPage={currentPageNo}
                            loading={loading}
                            showPrevLink={showPrevLink}
                            showNextLink={showNextLink}
                            show_start={showing_start}
                            show_end={showing_end}
                            total={this.state.totalResults}
                            type='WELLS'
                            handlePrevClick={(event) => this.handlePageClick(event, 'prev')}
                            handleNextClick={(event) => this.handlePageClick(event, 'next')}
                        />
                    : ''}
            </div>
        )
    }
}

const SearchWithDefaultBoundingBox = ({config}) => {
    let [searchParams, setSearchParams] = useSearchParams()
    const boundingBoxParam = searchParams.get('bbox')
    const initialBoundingBox = useMemo(() => {
        const bbox = boundingBoxParam ? boundingBoxParam.split(',') : null
        if (bbox) {
            return {
                west: Number(bbox[0]),
                south: Number(bbox[1]),
                east: Number(bbox[2]),
                north: Number(bbox[3])
            }
        }
        return null
    }, [boundingBoxParam])
    return <Search initialBoundingBox={initialBoundingBox} config={config} />
}

export default withConfig(SearchWithDefaultBoundingBox)
